import React, {Component} from 'react';

import style from '../css/toggleButton.css';

/**
 * This component returns a div with a checkCircle
 *
 * @param {string} htmlId
 * @param {function} callback - the callback function to be called on click
 * @param {object} style - css style to be aplyed to the main div
 * @param {boolean} isChecked - defines if the checkCircle is checked
 * @param {boolean} isEnabled - defines if the checkCircle is enabled
 */
export default class ToggleButton extends Component {
    render() {
        let htmlId = this.props.htmlId;
        let mainStyle = this.props.style;
        let isChecked = !this.props.isChecked;
        let isCheckStyle = isChecked
            ? style.checked
            : '';

        let callback = this.props.callback;
        let leftText = this.props.leftText;
        let rightText = this.props.rightText;
        let displayString = isChecked ? leftText : rightText;

        return (<div className={mainStyle} id={htmlId} data-toggled={isChecked}>
            <div className={`${style.toggle} ${isCheckStyle}`}>
                <div className={style.invisibleButton} onClick={callback}/>
                <div className={style.button}>{displayString}</div>
                <div className={style.labels}>
                    <div className={style.label}>{leftText}</div>
                    <div className={style.label}>{rightText}</div>
                </div>
            </div>
        </div>);
    }
}



// WEBPACK FOOTER //
// ./src/ui-modules/sports-book/components/toggleButton.js